import { render, staticRenderFns } from "./AdminRoles.vue?vue&type=template&id=c9460618&scoped=true"
import script from "./AdminRoles.vue?vue&type=script&lang=js"
export * from "./AdminRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9460618",
  null
  
)

export default component.exports